/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Horizontal_PushInputs */

const en_us2_catalog_movement_horizontal_push = /** @type {(inputs: Catalog_Movement_Horizontal_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`horizontal push`)
};

const pt_br2_catalog_movement_horizontal_push = /** @type {(inputs: Catalog_Movement_Horizontal_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`empurrar na horizontal`)
};

const es_419_catalog_movement_horizontal_push = /** @type {(inputs: Catalog_Movement_Horizontal_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`empuje horizontal`)
};

const pt_pt2_catalog_movement_horizontal_push = /** @type {(inputs: Catalog_Movement_Horizontal_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`empurrar na horizontal`)
};

const fr_fr2_catalog_movement_horizontal_push = /** @type {(inputs: Catalog_Movement_Horizontal_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`poussée horizontale`)
};

const de_de2_catalog_movement_horizontal_push = /** @type {(inputs: Catalog_Movement_Horizontal_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`horizontales Drücken`)
};

const it_it2_catalog_movement_horizontal_push = /** @type {(inputs: Catalog_Movement_Horizontal_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`spinta orizzontale`)
};

/**
* | output |
* | --- |
* | "horizontal push" |
*
* @param {Catalog_Movement_Horizontal_PushInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_horizontal_push = /** @type {((inputs?: Catalog_Movement_Horizontal_PushInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Horizontal_PushInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_horizontal_push(inputs)
	if (locale === "es-419") return es_419_catalog_movement_horizontal_push(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_horizontal_push(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_horizontal_push(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_horizontal_push(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_horizontal_push(inputs)
	return en_us2_catalog_movement_horizontal_push(inputs)
});
export { catalog_movement_horizontal_push as "catalog.movement.horizontal_push" }